import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'
const fb = require('../firebaseConfig.js')

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    categories: [],
    families: [],
    products: [],
    cart: [],
    orders: [],
    dataLoading: false,
    dataUploading: false,
  },
  actions: {
    // CATEGORIES
    addCategory({commit}, category) {
      const docRef = fb.db.collection('categories')
      const random = category.id
      docRef.doc(random).set({
        name: category.name,
        order: category.order
      }).then(res => {
        console.log('Category updated or created !')
      }).catch(error => {
        console.error('Error writing category: ', error)
      })
    },
    async deleteCategory({commit}, category) {
      const docRef = fb.db.collection('categories')
      const random = category.id
      try {
        const res = await docRef.doc(random).delete();
        console.log('Category deleted !');
      }
      catch (error) {
        console.error('Error deleting category: ', error);
      }
    },
    getCategories({commit}) {
      commit('setDataLoading', true)
      const docRef = fb.db.collection('categories')
      let currentCategories = []
      docRef.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let category = doc.data()
          category.id = doc.id
          currentCategories.push(category)
        })
        commit('setDataLoading', false)
        commit('setCategories', currentCategories)
      }).catch(err => {
        console.log(err)
      })
    },
    // FAMILIES
    async addFamily({commit}, family) {
      commit('setDataUploading', true)
      const docRef = fb.db.collection('families')
      const random = family.id
      const storage = firebase.storage()
      const familyRef = storage.ref('families/' + family.id + '/photo.jpg')
      let url = ''
      if (!family.needPhotoUpdate) {
        try {
          const urlTest = await familyRef.getDownloadURL();
          url = urlTest;
          docRef.doc(random).set({
            name: family.name,
            order: family.order,
            photo: url,
            parentId: family.parentId,
            parentName: family.parentName
          }).then(res => {
            commit('setDataUploading', false);
            console.log('Family updated or created !');
            return res;
          }).catch(error => {
            console.error('Error writing family: ', error);
          });
        }
        catch (err) {
          console.log(err);
        }
      } else {
        try {
          const snapshot = await familyRef.put(family.photo);
          console.log('Photo de la famille mis à jour!');
          try {
            const urlTest_1 = await familyRef.getDownloadURL();
            url = urlTest_1;
            docRef.doc(random).set({
              name: family.name,
              order: family.order,
              photo: url,
              parentId: family.parentId,
              parentName: family.parentName
            }).then(res_1 => {
              commit('setDataUploading', false);
              console.log('Family updated or created !');
              return res_1;
            }).catch(error_1 => {
              console.error('Error writing family: ', error_1);
            });
          }
          catch (err_1) {
            console.log(err_1);
          }
        }
        catch (err_2) {
          console.log(err_2);
        }
      }
    },
    getFamilies({commit}) {
      commit('setDataLoading', true)
      const docRef = fb.db.collection('families')
      let currentFamilies = []
      docRef.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let family = doc.data()
          family.id = doc.id
          currentFamilies.push(family)
        })
        commit('setDataLoading', false)
        commit('setFamilies', currentFamilies)
      }).catch(err => {
        console.log(err)
      })
    },
    getFamiliesByCategory({commit}, catId) {
      commit('setDataLoading', true)
      const docRef = fb.db.collection('families')
      let currentFamilies = []
      docRef.where('parentId', '==', catId).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let family = doc.data()
          family.id = doc.id
          currentFamilies.push(family)
        })
        commit('setDataLoading', false)
        commit('setFamilies', currentFamilies)
      }).catch(err => {
        console.log(err)
      })
    },
    async deleteFamily({commit}, family) {
      const docRef = fb.db.collection('families')
      const random = family.id
      try {
        const res = await docRef.doc(random).delete();
        console.log('Family deleted !');
      }
      catch (error) {
        console.error('Error deleting family: ', error);
      }
    },
    // PRODUCTS
    async addProduct({commit}, product) {
      commit('setDataUploading', true)
      const docRef = fb.db.collection('products')
      const random = product.id
      const storage = firebase.storage()
      const productRef = storage.ref('products/' + product.id + '/photo.jpg')
      let url = ''
      if (!product.needPhotoUpdate) {
        try {
          const urlTest = await productRef.getDownloadURL();
          url = urlTest;
          docRef.doc(random).set({
            name: product.name,
            ref: product.ref,
            cont: product.cont,
            photo: url,
            desc: product.desc,
            price: product.price,
            parentId: product.parentId,
            parentName: product.parentName
          }).then(res => {
            commit('setDataUploading', false);
            console.log('Product updated or created !');
            return res;
          }).catch(error => {
            console.error('Error writing product: ', error);
          });
        }
        catch (err) {
          console.log(err);
        }
      } else {
        try {
          const snapshot = await productRef.put(product.photo);
          console.log('Photo du produit mis à jour!');
          try {
            const urlTest_1 = await productRef.getDownloadURL();
            url = urlTest_1;
            docRef.doc(random).set({
              name: product.name,
              ref: product.ref,
              cont: product.cont,
              desc: product.desc,
              price: product.price,
              photo: url,
              parentId: product.parentId,
              parentName: product.parentName
            }).then(res_1 => {
              commit('setDataUploading', false);
              console.log('Product updated or created !');
              return res_1;
            }).catch(error_1 => {
              console.error('Error writing product: ', error_1);
            });
          }
          catch (err_1) {
            console.log(err_1);
          }
        }
        catch (err_2) {
          console.log(err_2);
        }
      }
    },
    getProducts({commit}) {
      commit('setDataLoading', true)
      const docRef = fb.db.collection('products')
      let currentProducts = []
      docRef.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let product = doc.data()
          product.id = doc.id
          currentProducts.push(product)
        })
        commit('setDataLoading', false)
        commit('setProducts', currentProducts)
      }).catch(err => {
        console.log(err)
      })
    },
    getProductsByFamily({commit}, famId) {
      commit('setDataLoading', true)
      const docRef = fb.db.collection('products')
      let currentProducts = []
      docRef.where('parentId', '==', famId).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let product = doc.data()
          product.id = doc.id
          currentProducts.push(product)
        })
        commit('setDataLoading', false)
        commit('setProducts', currentProducts)
      }).catch(err => {
        console.log(err)
      })
    },
    async deleteProduct({commit}, product) {
      const docRef = fb.db.collection('products')
      const random = product.id
      try {
        const res = await docRef.doc(random).delete();
        console.log('Product deleted !');
      }
      catch (error) {
        console.error('Error deleting product: ', error);
      }
    },
    // ORDERS
    orderCart({commit}, order) {
      const docRef = fb.db.collection('orders')
      const random = order.id
      docRef.doc(random).set({
        name: order.name,
        email: order.email,
        phone: order.phone,
        adress: order.adress,
        CP: order.CP,
        city: order.city,
        deleveryMode: order.deleveryMode,
        comments: order.comments,
        cart: order.cart,
        valid: false
      }).then(res => {
        console.log('Order created !')
      }).catch(error => {
        console.error('Error writing order: ', error)
      })
    },
    getOrders({commit}) {
      commit('setDataLoading', true)
      const docRef = fb.db.collection('orders')
      let currentOrders = []
      docRef.where('valid', '==', false).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let order = doc.data()
          order.id = doc.id
          currentOrders.push(order)
        })
        commit('setDataLoading', false)
        commit('setOrders', currentOrders)
      }).catch(err => {
        console.log(err)
      })
    },
    getOrdersDone({commit}) {
      commit('setDataLoading', true)
      const docRef = fb.db.collection('orders')
      let currentOrders = []
      docRef.where('valid', '==', true).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          let order = doc.data()
          order.id = doc.id
          currentOrders.push(order)
        })
        commit('setDataLoading', false)
        commit('setOrders', currentOrders)
      }).catch(err => {
        console.log(err)
      })
    },
    validateOrder({commit}, order) {
      const docRef = fb.db.collection('orders')
      docRef.doc(order.id).set({
        name: order.name,
        email: order.email,
        phone: order.phone,
        adress: order.adress,
        CP: order.CP,
        city: order.city,
        comments: order.comments,
        cart: order.cart,
        valid: true
      }).then(res => {
        console.log('Order validated !')
      }).catch(error => {
        console.error('Error writing order: ', error)
      })
    },
    async deleteOrder({commit}, order) {
      const docRef = fb.db.collection('orders')
      const id = order.id
      try {
        const res = await docRef.doc(id).delete();
        console.log('Product deleted !');
      }
      catch (error) {
        console.error('Error deleting product: ', error);
      }
    },

  },
  mutations: {
    setCategories(state, val) {
      state.categories = val
    },
    setFamilies(state, val) {
      state.families = val
    },
    setProducts(state, val) {
      state.products = val
    },
    setDataLoading(state, val) {
      state.dataLoading = val
    },
    setDataUploading(state, val) {
      state.dataUploading = val
    },
    setCart(state, cart) {
      state.cart = cart
    },
    setOrders(state, orders) {
      state.orders = orders
    },
    addToCart(state, product) {
      state.cart.push(product)
    },
    deleteFromCart(state, product) {
      state.cart.splice(state.cart.indexOf(product), 1)
    },
    setTotalProductPrice(state, product) {
      state.cart[state.cart.indexOf(product)].totalProductPrice = (product.quantity * parseFloat(product.price).toFixed(2)).toFixed(2)
    },
    clearCart(state) {
      state.cart = []
    }
  },
  getters: {
    categories: state => state.categories,
    families: state => state.families,
    products: state => state.products,
    cart: state => state.cart,
    orders: state => state.orders,
    dataLoading: state => state.dataLoading,
    dataUploading: state => state.dataUploading
  },
})



// WEBPACK FOOTER //
// ./src/store/store.js